import type { Icon } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
import type { JSX } from 'react';

export const HEADER_TITLE_DEFAULT_ID = 'header-title';

export type HeaderTitleProps = {
  display?: 'flex' | 'block' | 'inline' | 'inline-flex' | 'grid';
  flexDirection?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  gap?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  icon?: Icon;
  marginBottom?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  marginTop?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  subtitle?: string | JSX.Element;
  title: string | JSX.Element;
  titleElementId?: string;
  zIndex?: number | string;
};

const GAP_CLASS: Record<number, string> = {
  0: 'gap-0',
  1: 'gap-0.5',
  2: 'gap-1',
  3: 'gap-2',
  4: 'gap-3',
  5: 'gap-4',
  6: 'gap-5',
  7: 'gap-6',
  8: 'gap-8',
};

const MT_CLASS: Record<number, string> = {
  0: '',
  1: 'mt-0.5',
  2: 'mt-1',
  3: 'mt-2',
  4: 'mt-3',
  5: 'mt-4',
  6: 'mt-5',
  7: 'mt-6',
  8: 'mt-8',
};

const MB_CLASS: Record<number, string> = {
  0: '',
  1: 'mb-0.5',
  2: 'mb-1',
  3: 'mb-2',
  4: 'mb-3',
  5: 'mb-4',
  6: 'mb-5',
  7: 'mb-6',
  8: 'mb-8',
};

const HeaderTitle = ({
  display,
  flexDirection,
  gap = 3,
  icon: Icon,
  marginTop = 0,
  marginBottom = 0,
  subtitle,
  title,
  titleElementId = HEADER_TITLE_DEFAULT_ID,
  zIndex,
}: HeaderTitleProps) => {
  const gapClass = GAP_CLASS[gap] ?? '';
  const mtClass = MT_CLASS[marginTop] ?? '';
  const mbClass = MB_CLASS[marginBottom] ?? '';

  return (
    <div
      className={cx(
        'flex items-center flex-col text-center',
        gapClass,
        mtClass,
        mbClass,
        display === 'block' && 'block',
        display === 'inline' && 'inline',
        display === 'inline-flex' && 'inline-flex',
        display === 'grid' && 'grid',
        flexDirection === 'row' && 'flex-row',
        flexDirection === 'row-reverse' && 'flex-row-reverse',
        flexDirection === 'column-reverse' && 'flex-col-reverse',
      )}
      style={{ zIndex }}
    >
      {Icon && <Icon color="primary" />}
      <div className="flex flex-col items-center gap-2">
        <h2 className="text-heading-3 text-primary fp-text" id={titleElementId}>
          {title}
        </h2>
        {subtitle && <h3 className="text-body-2 text-secondary fp-text">{subtitle}</h3>}
      </div>
    </div>
  );
};

export default HeaderTitle;
